<template>
    <div style="height:100%;background:#A8A8A8;position:relative;">
        <div class="left-ball-top"></div>
        <div class="right-ball-top"></div>
        <div id="china_map_north" ref="ChinaEchart" style="width: 100%; "></div>
        <div class="main-area">
            <div class="left-ball"></div>
            <div class="right-ball"></div>
            <div class="title">
                <div class="num-box" id="company1">1</div><span>{{$t('globalNet.function[0].componey[0].conpanyName')}}</span>
                <div style="height:18px;"></div>
                <div class="bottom-box">
                    <div class="item">
                        <div class="content">{{$t('globalNet.function[0].componey[0].address1')}}</div>
                        <div class="content">{{$t('globalNet.function[0].componey[0].address2')}}</div>
                    </div>
                    <div class="item">
                        <div class="content"><img src="../../assets/images/phone.svg">{{$t('globalNet.function[0].componey[0].phone')}}</div>
                        <div class="content"><img src="../../assets/images/mail.svg">{{$t('globalNet.function[0].componey[0].mail')}}</div>
                    </div>
                </div>
                <div style="height:55px;"></div>
                <div class="num-box" id="company2">2</div><span>{{$t('globalNet.function[0].componey[1].conpanyName')}}</span>
                <div style="height:18px;"></div>
                <div class="bottom-box">
                    <div class="item">
                        <div class="content">{{$t('globalNet.function[0].componey[1].address1')}}</div>
                        <div class="content">{{$t('globalNet.function[0].componey[1].address2')}}</div>
                    </div>
                    <div class="item">
                        <div class="content"><img src="../../assets/images/phone.svg">{{$t('globalNet.function[0].componey[1].phone')}}</div>
                        <div class="content"><img src="../../assets/images/mail.svg">{{$t('globalNet.function[0].componey[1].mail')}}</div>
                    </div>
                </div>
                <div style="height:55px;"></div>
                <div class="num-box" id="company3">3</div><span>{{$t('globalNet.function[0].componey[2].conpanyName')}}</span>
                <div style="height:18px;"></div>
                <div class="bottom-box">
                    <div class="item">
                        <div class="content">{{$t('globalNet.function[0].componey[2].address1')}}</div>
                        <div class="content">{{$t('globalNet.function[0].componey[2].address2')}}</div>
                    </div>
                    <div class="item">
                        <div class="content"><img src="../../assets/images/phone.svg">{{$t('globalNet.function[0].componey[2].phone')}}</div>
                        <div class="content"><img src="../../assets/images/mail.svg">{{$t('globalNet.function[0].componey[2].mail')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from "echarts"
import '../../../node_modules/echarts/map/js/china.js' //引入中国地图
export default ({
    data() {
        return {
            pointData: [],
            companyData:[
                [{
                    name: "1",
                    value: [121.613759,31.176032]
                }],
                [{
                    name: "2",
                    value: [115.796046,28.194305]
                }],
                [{
                    name: "3",
                    value: [120.477571,32.005347]
                }],
            ],
            options:{},
            dataList: [
            {
                name: "上海",
                value: 201
            },
            {
                name: "天津",
                value: 101
            },
            {
                name: "江苏",
                value: 201
            },
            {
                name: "江西",
                value: 101
            },
            {
                name: "广东",
                value: 101
            },
            {
                name: "四川",
                value: 101
            },
            {
                name: "河北",
                value: 101
            },
            ]
        }
    },
    created() {
        var lang = localStorage.getItem('lang')
        if(lang == 'en') {
        this.pointData = [{
            name: "South West",
            value: [104.104733,30.652319]
        },{
            name: "North China",
            value: [116.33943,39.125274]
        },{
            name: "East China",
            value: [121.504642,31.24186]
        },{
            name: "South China",
            value: [113.745411,23.019925]
        }]
        }else{
        this.pointData = [{
            name: "西南",
            value: [104.104733,30.652319]
        },{
            name: "华北",
            value: [116.33943,39.125274]
        },{
            name: "华东",
            value: [121.504642,31.24186]
        },{
            name: "华南",
            value: [113.745411,23.019925]
        }]
        }
        this.setEchartOption();
    },
    mounted: function () {
        this.$nextTick(()=>{
            this.initMap()
        })    
    },
    methods: {
        initMap(){
            let mapDiv = document.getElementById('china_map_north')
            let myChart = echarts.init(mapDiv)
            myChart.setOption(this.options)
            myChart.on('click', function (params) {
                if(params.seriesIndex == 1 || params.seriesIndex == 2 || params.seriesIndex == 3){
                    var pageId = document.querySelector('#company' + params.seriesIndex)
                    window.scrollTo({
                        'top': pageId.offsetTop + 150,
                        'behavior': 'smooth'
                    })
                }
            })
        },
        //修改echart配制
        setEchartOption(){
            this.options = {
                visualMap: {
                    min: 0,
                    max: 1000,
                    left: 26,
                    bottom: 40,
                    seriesIndex: [0],
                    pieces: [{
                        gte: 0,
                        lte: 102,
                        color: "#cdcdcd"
                    },{
                        gt: 200,
                        color: "#ED6D00",
                    }],
                    show: false
                },
                geo: {
                    map: "china",
                    zoom: 1,
                    top: 70,
                    label: {
                        normal: {
                            show:false,
                        },
                        emphasis: {
                            show:false
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: "#ffffff",
                            borderColor: "rgba(0, 0, 0, 0.2)"
                        },
                        emphasis: {
                            areaColor: "#ED6D00",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    }
                },
                series: [
                    {
                        name: "",
                        type: "map",
                        geoIndex: 0,
                        data:[],
                        itemStyle: {
                            normal: {
                                color: '#ED6D00' //标志颜色
                            },
                            emphasis: {
                                show: false,
                                // color: '#717171'
                            }
                        }
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.companyData[0],
                        symbol: "image://" + require('@/assets/images/point1.svg'),
                        symbolSize: [20,25],
                        label: {
                            show: false
                        },
                        itemStyle: {
                            color: 'red'
                        },
                        zlevel: 1,
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.companyData[1],
                        symbol: "image://" + require('@/assets/images/point2.svg'),
                        symbolSize: [20,25],
                        label: {
                            show: false
                        },
                        itemStyle: {
                            color: 'red'
                        },
                        zlevel: 1,
                    },
                    {
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.companyData[2],
                        symbol: "image://" + require('@/assets/images/point3.svg'),
                        symbolSize: [20,25],
                        label: {
                            show: false
                        },
                        itemStyle: {
                            color: 'red'
                        },
                        zlevel: 1,
                    },
                    {
                        name: '地址',
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.pointData,
                        symbol:'circle',
                        symbolSize: [8, 8],
                        label: {
                            normal: {
                                show: true,
                                formatter: function (params) {
                                    return params.name
                                },
                                position: 'top',
                                color: '#ED6D00',
                                fontSize: '20',
                            }
                        },
                        itemStyle: {
                            color: '#ED6D00'
                        }
                    }
                ]
            }
            this.options.series[0]['data'] = this.dataList;
        }
    }
})
</script>
<style scoped>
    #china_map_north{
        height: 320px
    }
    @media screen and (max-width: 1399px) {
        #china_map_north {
            height: 320px;
        }
    }
    .main-area{
        position: relative;
        background: #ffffff;
        padding: 55px 50px;
        border-top: 1px solid #ED6D00;
    }
    .left-ball-top{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        left: -15px;
        border-radius: 50%;
        z-index: 2;
    }
    .left-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        left: -15px;
        border-radius: 50%;
        z-index: 2;
    }
    .right-ball-top{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: 0;
        border-radius: 50%;
    }
    .right-ball{
        width: 30px;
        height: 30px;
        background: #ED6D00;
        position: absolute;
        top: -15px;
        right: -15px;
        border-radius: 50%;
    }
    .title{
        margin-bottom: 18px;
    }
    .num-box{
        display: inline-block;
        margin-right: 10px;
        width: 30px;
        height: 30px;
        background: #ED6D00;
        border-radius: 50%;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
    }
    .bottom-box{
        display: flex;
    }
    .bottom-box .item{
        width: 50%;
    }
    .content{
        font-size: 18px;
        margin-left: 40px;
        font-weight: 500;
    }
    .content img{
        vertical-align: middle;
        position: relative;
        bottom: 2px;
        margin-right: 10px;
        width: 18px;
    }
    @media screen and (max-width:768px) {
        #china_map_north{
            height: 380px
        }
        .main-area{
            padding: 50px 20px 100px 20px;
        }
        .bottom-box .item{
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/southChina/southChina.vue